import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      notificationItem: this.props.notificationItem,
    };
  },
  onError() {
    var updated = this.state.notificationItem;
    updated.thumbnail_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      notificationItem: updated,
    });
  },
  render() {
    var timeAgo = this.state.notificationItem.created_at_time_ago_format;
    return (
      <div>
        <a
          href={this.props.notificationItem.url}
          id="notification-item"
          className="notification"
        >
          <li>
            <div
              className="row justify-content-around align-items-center py-3 circles_menu_border"
              style={{ backgroundColor: "#ffffff", margin: "0 0.5px 0 0.5px" }}
            >
              <div className="col-2 pr-1">
                <img
                  src={this.state.notificationItem.thumbnail_image_url}
                  onError={this.onError}
                  className="icon-for-notification"
                  alt=""
                />
              </div>
              <div className="col pl-3">
                <p
                  className="mb-0"
                  dangerouslySetInnerHTML={{
                    __html: this.state.notificationItem.title,
                  }}
                  style={{ fontSize: "14px" }}
                />
                {this.state.notificationItem.body && (
                  <p
                    className="mt-2 mb-2"
                    dangerouslySetInnerHTML={{
                      __html: this.state.notificationItem.body,
                    }}
                    style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}
                  />
                )}
                  <p className="text-fz-small text-black-50 mb-0 mt-3" style={{ fontSize: '10px' }}>{timeAgo}</p>
              </div>
              <span className="nav-link link--arrow text-center" style={{ width: "10%" }}>
              </span>
            </div>
          </li>
        </a>
      </div>
    );
  },
});
